import styled from 'styled-components';
import theme from '../../assets/styles/theme';

const getMediaQuery = (key) => (style) =>
  `@media (min-width: ${theme.breakpoints[key].size}) { gap: ${theme.breakpoints[key].gap}; ${style}}`;

const getGridTemplateAreas = (value) => `grid-template-areas: ${value};`;

export const Grid = styled.div`
  display: grid;
  height: 100%;

  ${({ xxs }) => xxs && getMediaQuery('xxs')(getGridTemplateAreas(xxs))}
  ${({ xs }) => xs && getMediaQuery('xs')(getGridTemplateAreas(xs))}
  ${({ s }) => s && getMediaQuery('s')(getGridTemplateAreas(s))}
  ${({ m }) => m && getMediaQuery('m')(getGridTemplateAreas(m))}
  ${({ l }) => l && getMediaQuery('l')(getGridTemplateAreas(l))}
`;

export const Area = styled.div`
  ${({ name }) => `grid-area:${name};`}
`;
